<template>
  <div class="module_page page_content institution kc_desc_config" aria-label="Configure Knowledge Check Description">
    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-4 btn_container" v-if="isEditClicked">
        <b-btn @click="saveClicked">save</b-btn>
        <b-btn class="btn-cancel" @click="cancelClicked" title="Cancel"><span class="icon-cross"></span></b-btn>
      </div>
      <div class="col-4 btn_container" v-else>
        <b-btn @click="isEditClicked = true">edit</b-btn>
      </div>
    </div>
    <div class="page_content_container">
      <institution-menu :uuid="uuid" :active="'kcDescription'"></institution-menu>
      <div class="row pg_content">
        <div class="col-12">
          <div class="row">
            <div class="col-12 pg_fld_sec">
              <div class="row pg_fld_row">
                <div>
                  <input type="checkbox" class="create-person-field" id="checkbox" aria-labelledby="Override Assessment Description" v-model="overrideAssessmentDescription" :disabled="!isEditClicked">

                  <span style="margin-bottom: 10px; font-weight: bold; font-size: large;">Override Assessment Description</span>
                  <div style="margin-top: 10px;margin-left: 15px; ">If “Override Assessment description” is checked, the KC Description messages configured below will be shown instead of the description configured per KC.</div>
                  <div style="margin-left: 15px;" >If the “Override Assessment description” is not checked, then individual KCs have a description, they will be displayed. If not, the KC Description messages below will be displayed.</div>
                  <div style="margin-left: 15px;">These rules apply to all Knowledge Checks, including diagnostic and practice tests.</div>

                </div>
              </div>
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="knowledgeCheckDescription"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="knowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.knowledgeCheckDescription">
                    <div class="text-area p-2" v-html="institution.knowledgeCheckDescription"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <!-- Problem Based Courses -->
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Problem Based Courses
              </div>
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                First KC Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblKc1"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblKc1KnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblKc1">
                    <div class="text-area p-2" v-html="institution.pblKc1"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Last KC Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblLastKc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblLastKcKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblLastKc">
                    <div class="text-area p-2" v-html="institution.pblLastKc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
               1st KC of an Micro Competency Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblKc1Mc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblKc1McKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblKc1Mc">
                    <div class="text-area p-2" v-html="institution.pblKc1Mc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Any Other KC Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblAnyKc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblAnyKcKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblAnyKc">
                    <div class="text-area p-2" v-html="institution.pblAnyKc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after KC Fail
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblKcFail"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblKcFailKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblKcFail">
                    <div class="text-area p-2" v-html="institution.pblKcFail"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
               Message after KC Fail - but more KCs exist
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblKcFailWithMoreKcs"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblKcFailWithMoreKcsKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblKcFailWithMoreKcs">
                    <div class="text-area p-2" v-html="institution.pblKcFailWithMoreKcs"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
               Message after Last KC Fail
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblLastKcFail"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblLastKcFailKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblLastKcFail">
                    <div class="text-area p-2" v-html="institution.pblLastKcFail"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after KC Pass
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="pblKcPass"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="pblKcPassKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.pblKcPass">
                    <div class="text-area p-2" v-html="institution.pblKcPass"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <!-- Competency Based Courses -->
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Competency Based Courses
              </div>
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                First KC Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblKc1"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblKc1KnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblKc1">
                    <div class="text-area p-2" v-html="institution.cblKc1"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Last KC Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblLastKc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblLastKcKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblLastKc">
                    <div class="text-area p-2" v-html="institution.cblLastKc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
               1st KC of an Micro Competency Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblKc1Mc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblKc1McKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblKc1Mc">
                    <div class="text-area p-2" v-html="institution.cblKc1Mc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Any Other KC Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblAnyKc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblAnyKcKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblAnyKc">
                    <div class="text-area p-2" v-html="institution.cblAnyKc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after KC Fail
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblKcFail"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblKcFailKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblKcFail">
                    <div class="text-area p-2" v-html="institution.cblKcFail"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
               Message after KC Fail - but more KCs exist
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblKcFailWithMoreKcs"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblKcFailWithMoreKcsKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblKcFailWithMoreKcs">
                    <div class="text-area p-2" v-html="institution.cblKcFailWithMoreKcs"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
               Message after Last KC Fail
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblLastKcFail"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblLastKcFailKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblLastKcFail">
                    <div class="text-area p-2" v-html="institution.cblLastKcFail"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after KC Pass
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="cblKcPass"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="cblKcPassKnowledgeCheckDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.cblKcPass">
                    <div class="text-area p-2" v-html="institution.cblKcPass"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Pre Diagnostic Test Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="preDiagnosticTestDesc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="preDiagnosticTestDescId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.preDiagnosticTestDesc">
                    <div class="text-area p-2" v-html="institution.preDiagnosticTestDesc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Post Diagnostic Test Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="postDiagnosticTestDesc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="postDiagnosticTestDescId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.postDiagnosticTestDesc">
                    <div class="text-area p-2" v-html="institution.postDiagnosticTestDesc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Practice Test Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="praticeTestDesc"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="praticeTestDescId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.praticeTestDesc">
                    <div class="text-area p-2" v-html="institution.praticeTestDesc"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>              

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after 1st or any Diagnostic Test
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="diagnosticTestFirstMessage"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="diagnosticTestFirstMessageId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.diagnosticTestFirstMessage">
                    <div class="text-area p-2" v-html="institution.diagnosticTestFirstMessage"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after last Diagnostic Test
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="diagnosticTestLastMessage"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="diagnosticTestLastMessageId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.diagnosticTestLastMessage">
                    <div class="text-area p-2" v-html="institution.diagnosticTestLastMessage"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Description Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after Competency Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="messageAfterCompetencyDescription"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="messageAfterCompetencyDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.messageAfterCompetencyDescription">
                    <div class="text-area p-2" v-html="institution.messageAfterCompetencyDescription"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Message Provided"></b-form-textarea>
                  </template>
                </template>
              </div>

              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Message after Micro Competency Description
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                  <editor api-key="no-api-key"
                    v-model.trim="messageAfterMicroCompetencyDescription"
                    :init="({
                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                      menubar: false,
                      plugins: plugins,
                      toolbar: toolbar,
                      branding: false,
                      statusbar: false,
                      end_container_on_empty_block: true
                    })"
                    @onInit="handlerInit"
                    id="messageAfterMicroCompetencyDescriptionId">
                  </editor>
                </template>
                <template v-else>
                  <template v-if="institution.messageAfterMicroCompetencyDescription">
                    <div class="text-area p-2" v-html="institution.messageAfterMicroCompetencyDescription"></div>
                  </template>
                  <template v-else>
                    <b-form-textarea readonly no-auto-shrink rows="10" max-rows="10" style="width: 100%;" placeholder="No Message Provided"></b-form-textarea>
                  </template>
                </template>
              </div>
              <div class="row pg_fld_row module_type_name" style="margin-bottom: 10px; font-weight: bold; font-size: large;">
                Manual Grading Question score % (Example 65) cutoff for Diagnostic Test logic
              </div>
              <div class="row pg_fld_row">
                <template v-if="isEditClicked">
                <input size=2 v-model="manualGradQuesCutOffForDT"></input> %
                </template>
                <template v-else>
                    <div> {{institution.manualGradQuesCutOffForDT}}%</div>
                </template>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import Editor from '@tinymce/tinymce-vue'
  import InstitutionMenu from './InstitutionMenu'

  export default {
    name: 'institutionKnowledgeCheckDescription',
    props: ['uuid'],
    components: {
      Editor,
      InstitutionMenu
    },
    data: () => {
      return {
        isEditClicked: false,
        knowledgeCheckDescription: undefined,
        pblKc1: undefined,
        pblAnyKc: undefined,
        pblLastKc: undefined,
        pblKcFail: undefined,
        pblKcFailWithMoreKcs: undefined,
        pblKcPass: undefined,
        pblKc1Mc: undefined,
        cblKc1: undefined,
        cblAnyKc: undefined,
        cblLastKc: undefined,
        cblKcFail: undefined,
        cblKcFailWithMoreKcs: undefined,
        cblKcPass: undefined,
        cblKc1Mc: undefined,
        diagnosticTestFirstMessage: undefined,
        preDiagnosticTestDesc: undefined,
        postDiagnosticTestDesc: undefined,
        praticeTestDesc: undefined,
        diagnosticTestLastMessage: undefined,
        messageAfterCompetencyDescription: undefined,
        messageAfterMicroCompetencyDescription: undefined,
        manualGradQuesCutOffForDT : 65,
        overrideAssessmentDescription: false,
        plugins: 'lists  autolink charmap code hr link textcolor',
        toolbar: 'bold italic strikethrough | bullist numlist | indent outdent | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink'
      }
    },
    mounted () {
      this.knowledgeCheckDescription = this.institution.knowledgeCheckDescription
      this.overrideAssessmentDescription = this.institution.overrideAssessmentDescription
      this.pblKc1 = this.institution.pblKc1
      this.pblAnyKc = this.institution.pblAnyKc
      this.pblLastKc = this.institution.pblLastKc
      this.pblKcFail = this.institution.pblKcFail
      this.pblKcFailWithMoreKcs = this.institution.pblKcFailWithMoreKcs
      this.pblLastKcFail = this.institution.pblLastKcFail
      this.pblKcPass = this.institution.pblKcPass
      this.pblKc1Mc = this.institution.pblKc1Mc
      this.cblKc1 = this.institution.cblKc1
      this.cblAnyKc = this.institution.cblAnyKc
      this.cblLastKc = this.institution.cblLastKc
      this.cblKcFail = this.institution.cblKcFail
      this.cblKcFailWithMoreKcs = this.institution.cblKcFailWithMoreKcs
      this.cblLastKcFail = this.institution.cblLastKcFail
      this.cblKcPass = this.institution.cblKcPass
      this.cblKc1Mc = this.institution.cblKcPass
      this.diagnosticTestFirstMessage = this.institution.diagnosticTestFirstMessage
      this.preDiagnosticTestDesc = this.institution.preDiagnosticTestDesc
      this.postDiagnosticTestDesc = this.institution.postDiagnosticTestDesc
      this.praticeTestDesc = this.institution.praticeTestDesc
      this.diagnosticTestLastMessage = this.institution.diagnosticTestLastMessage
      this.messageAfterCompetencyDescription = this.institution.messageAfterCompetencyDescription
      this.messageAfterMicroCompetencyDescription = this.institution.messageAfterMicroCompetencyDescription
      this.manualGradQuesCutOffForDT = this.institution.manualGradQuesCutOffForDT
    },
    methods: {
      ...mapActions([
        'storeInstitution',
        'loadInstitutionDetail'
      ]),
      handlerInit (ev, editor) {
        $('#knowledgeCheckDescriptionId_ifr').css({width: '100%', height: '250px', border: '1px solid #ccc'})
      },
      cancelClicked () {
        this.isEditClicked = false
      },
      async saveClicked () {
        if (this.knowledgeCheckDescription) {
          this.institution.knowledgeCheckDescription = this.knowledgeCheckDescription
        } else {
          this.institution.knowledgeCheckDescription = undefined
        }
        this.institution.overrideAssessmentDescription = this.overrideAssessmentDescription
        this.institution.pblKc1 = this.pblKc1
        this.institution.pblAnyKc = this.pblAnyKc
        this.institution.pblLastKc = this.pblLastKc
        this.institution.pblKcFail = this.pblKcFail
        this.institution.pblKcFailWithMoreKcs = this.pblKcFailWithMoreKcs
        this.institution.pblLastKcFail = this.pblLastKcFail
        this.institution.pblKcPass = this.pblKcPass
        this.institution.pblKc1Mc = this.pblKc1Mc
        this.institution.cblKc1 = this.cblKc1
        this.institution.cblAnyKc = this.cblAnyKc
        this.institution.cblLastKc = this.cblLastKc
        this.institution.cblKcFail = this.cblKcFail
        this.institution.cblKcFailWithMoreKcs =  this.cblKcFailWithMoreKcs
        this.institution.cblLastKcFail = this.cblLastKcFail
        this.institution.cblKcPass = this.cblKcPass
        this.institution.cblKc1Mc = this.cblKc1Mc
        this.institution.diagnosticTestFirstMessage = this.diagnosticTestFirstMessage
        this.institution.preDiagnosticTestDesc = this.preDiagnosticTestDesc
        this.institution.postDiagnosticTestDesc = this.postDiagnosticTestDesc
        this.institution.praticeTestDesc = this.praticeTestDesc
        this.institution.diagnosticTestLastMessage = this.diagnosticTestLastMessage
        this.institution.messageAfterCompetencyDescription = this.messageAfterCompetencyDescription
        this.institution.messageAfterMicroCompetencyDescription = this.messageAfterMicroCompetencyDescription
        this.institution.manualGradQuesCutOffForDT = this.manualGradQuesCutOffForDT
        let response = await this.storeInstitution(this.institution)
        if (response && response.uuid) {
          let message = 'Knowledge Check description updated successfully'
          this.notifySuccess(message)
        } else {
          let message = 'Unable to update Knowledge Check description'
          this.notifyFailure(message)
        }
        if (!this.knowledgeCheckDescription) {
          await this.loadInstitutionDetail(this.uuid)
        }
        this.isEditClicked = false
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution
      })
    }
  }
</script>

<style>
  div.text-area {
    width: 100%;
    height: 250px;
    background-color: #e9ecef;
  }
  .kc_desc_config .mce-tinymce .mce-top-part {
    position: relative;
    background: #fafafa;
    width: 100%;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionKnowledgeCheckDescription.vue